import { render } from "./ChannelSelector.vue?vue&type=template&id=0b06e066"
import script from "./ChannelSelector.vue?vue&type=script&lang=js"
export * from "./ChannelSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__